import React from 'react';

export type LogPageContextType = [
  name: string,
  metadata: Record<string, unknown> | null
];
export const LogPageContext = React.createContext<LogPageContextType | null>(
  null
);
